module.exports = __webpack_public_path__ + "static/img/104_TO8_1786_og.6d810ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/104_TO8_1786_og.jpg
// module id = vzK+
// module chunks = 0